module.exports = __webpack_public_path__ + "ef6b48bd941f183d94611575f798bf45.png";